<template>
    <div class="animated fadeIn page-new">
        <b-row>
            <b-form @submit.prevent="save" action="111" class="col-md-12" aria-autocomplete="none">
                <b-row>
                    <b-col sm="12" class="main-page">
                        <b-card footer-tag="footer">
                            <div slot="header">
                                <strong>Thêm thành viên</strong>
                            </div>
                            <b-row  v-bind:class="{'ptt-loading':loading}">
                                <b-col cols="12" xl="6" lg="8">
                                  <p class="text-muted font-italic">Trường <span style='color:red'>*</span> bắt buộc</p>

                                  <b-form-group
                                    label-for="input-name"
                                    :label-cols="2"
                                    :horizontal="true">
                                    <template slot="label">
                                      Tên thành viên <span style="color:red">*</span>
                                    </template>
                                    <b-form-input id="input-name"
                                                  type="text"
                                                  placeholder="Nhập tên thành viên"
                                                  v-model="data.name"
                                                  required
                                                  autocomplete="off"></b-form-input>
                                  </b-form-group>

                                  <b-form-group
                                            label="Địa chỉ email <span style='color:red'>*</span>"
                                            label-for="input-email"
                                            :label-cols="2"
                                            :horizontal="true">
                                    <template slot="label">
                                      Địa chỉ email <span style='color:red'>*</span>
                                    </template>
                                        <b-form-input id="input-email" type="email" placeholder="Nhập email thành viên"  v-model="data.email" autocomplete="off"></b-form-input>
                                    </b-form-group>
                                    <b-form-group
                                            label="Địa chỉ"
                                            label-for="input-address"
                                            :label-cols="2"
                                            :horizontal="true">
                                        <b-form-input id="input-address" type="text" placeholder="Nhập địa chỉ"  v-model="data.address" autocomplete="off"></b-form-input>
                                    </b-form-group>
                                    <b-form-group
                                            label="Số điện thoại"
                                            label-for="input-phone"
                                            :label-cols="2"
                                            :horizontal="true">
                                        <b-form-input id="input-phone" type="text" placeholder="Nhập số điện thoại"  v-model="data.phone" autocomplete="off"></b-form-input>
                                    </b-form-group>
                                    <b-form-group
                                            label="Ngày sinh"
                                            label-for="input-birthday"
                                            :label-cols="2"
                                            :horizontal="true">
                                        <b-form-input id="input-birthday" type="date" placeholder="Nhập ngày sinh"  v-model="data.birthday" autocomplete="off"></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                            label="Mật khẩu <span style='color:red'>*</span>"
                                            label-for="input-pass"
                                            :label-cols="2"
                                            :horizontal="true">
                                      <template slot="label">
                                        Mật khẩu <span style='color:red'>*</span>
                                      </template>
                                        <b-form-input id="input-pass" type="password" placeholder="Nhập mật khẩu"  v-model="data.password" autocomplete="off"></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                            label="Nhập lại mật khẩu <span style='color:red'>*</span>"
                                            label-for="input-pass2"
                                            :label-cols="2"
                                            :horizontal="true">
                                      <template slot="label">
                                        Nhập lại mật khẩu <span style='color:red'>*</span>
                                      </template>
                                        <b-form-input id="input-pass2" type="password" placeholder="Nhập lại mật khẩu"  v-model="password2" autocomplete="off"></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                            label="Số thiết bị <span style='color:red'>*</span>"
                                            label-for="input-device-limit"
                                            :label-cols="2"
                                            :horizontal="true">
                                      <template slot="label">
                                        Số thiết bị <span style='color:red'>*</span>
                                      </template>
                                        <b-form-input id="input-device-limit"
                                                      type="number"
                                                      placeholder="Nhập số thiết bị được truy cập"
                                                      v-model="data.device_limit" autocomplete="off"></b-form-input>
                                    </b-form-group>
                                    <b-row>
                                        <b-col cols="12" xl="6" lg="8">
                                            <b-form-group
                                                    label="Trạng thái"
                                                    label-for="input-status"
                                                    :label-cols="4"
                                                    :horizontal="true">
                                                <b-form-select id="input-status" v-model="data.status">
                                                    <option :value="1">Đang hoạt động</option>
                                                    <option :value="2">Ngừng hoạt động</option>
                                                    <option :value="3">Tạm Khóa</option>
                                                </b-form-select>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" xl="4" lg="4" class="d-none">
                                                <b-form-group
                                                        label="Level"
                                                        label-for="input-level"
                                                        :label-cols="4"
                                                        :horizontal="true">
                                                    <b-form-select id="input-level" v-model="data.level">
                                                        <option :value="1">1</option>
                                                        <option :value="2">2</option>
                                                        <option :value="3">3</option>
                                                        <option :value="4">4</option>
                                                        <option :value="5">5</option>
                                                        <option :value="6">Hoạt Động</option>
                                                    </b-form-select>
                                                </b-form-group>
                                        </b-col>
                                    </b-row>

                                </b-col>
                            </b-row>
                            <div slot="footer" class="">
                                <b-button type="submit" variant="primary">Tạo thành viên</b-button>
                                <b-button type="button" class="ml-2" :to="{path:'/users'}">Quay lại</b-button>
                            </div>
                        </b-card>
                    </b-col>
                </b-row>
            </b-form>
        </b-row>
    </div>
</template>

<script>
export default {
  name: 'UserAdd',
  components: {},
  data() {
    return {
      data: {
        name: null,
        email: "",
        group: null,
        password: "",
        phone: null,
        address: null,
        birthday: null,
        image: null,
        device_limit: 3,
        level: 6,
        status: 1,
      },
      password2: null,
      loading: false,
      group: []
    }
  },
  created() {
  },
  computed: {
    isAdmin() {
      return this.$userLogged && this.$userLogged.group_name === 'administrator'
    },
    isSuperAdmin() {
      return this.$userLogged && this.$userLogged.group_name === 'supper-admin'
    },

  },
  watch: {},
  methods: {
    async save() {
      const user = this.$cookies.get('user');
      this.$gtag.event('click_create_member', {
        event_category: 'click_events',
        event_label: 'Create member button',
        user_type: 'admin',
        user_id: user?._id,
      });
      //kiem tra bat buoc
      if (!this.data.name) {
        this.$toasted.show("Vui lòng nhập tên", {
          type: "error",
          duration: 5000
        });
        return false;
      }
      if (!this.data.email) {
        this.$toasted.show("Vui lòng nhập địa chỉ email", {
          type: "error",
          duration: 5000
        });
        return false;
      }

      if (!this.data.password) {
        this.$toasted.show("Vui lòng nhập mật khẩu", {
          type: "error",
          duration: 5000
        });
        return false;
      }

      if (this.data.password !== this.password2) {
        this.$toasted.show("Nhập lại mật khẩu không chính xác", {
          type: "error",
          duration: 5000
        });
        return false;
      }

      //Lưu lại
      if (!this.data.device_limit) {
        this.$toasted.show("Vui lòng chọn Số thiết bị", {
          type: "error",
          duration: 5000
        });
        return false;
      }
      this.data.device_limit = parseInt(this.data.device_limit) // convert ra số

      if (!this.data.level) {
        this.$toasted.show("Vui lòng chọn Level", {
          type: "error",
          duration: 5000
        });
        return false;
      }
      this.data.level = parseInt(this.data.level) // convert ra số

      this.loading = true
      try {
        let {data}  = await this.$axios.post(this.$configs.api + '/api/v4/cp/users/register', {
          ...this.data
        })

        this.$gtag.event('create_member', {
          event_category: 'member_events',
          event_label: 'Create member',
          user_type: 'admin',
          user_id: user?._id,
          req: JSON.stringify(this.data) || null,
          res: JSON.stringify(data) || null,
        });

        if (data && data._id) {
          this.$toasted.success("Đã tạo tài khoản thành công", {
            duration: 3000
          });
          this.$router.push({path: `/users/${data._id}`})
        }

      } catch (err) {
        if (err && err.response) {
          if (err.response.data && err.response.data.message) {
            this.$toasted.show(err.response.data.message, {
              type: "error",
              duration: 3000
            });
            return false;
          }
        } else {
          this.$toasted.show("Đã có lỗi hệ thống xảy ra", {
            type: "error",
            duration: 3000
          });
        }
      } finally {
        this.loading = false
      }

    }
  }
}
</script>

